// Mock data for recording studio website

export const studioInfo = {
  name: "StudioKyp",
  tagline: "Votre son, notre passion",
  description: "StudioKyp - Studio d'enregistrement professionnel équipé des dernières technologies pour donner vie à vos projets musicaux.",
  phone: "+33 1 23 45 67 89",
  email: "contact@studiokyp.fr",
  address: "Hotel de la musique Saint-Marcel, Local 129, 13011 MARSEILLE",
  hours: "Lun - Sam: 9h00 - 22h00"
};

export const services = [
  {
    id: 1,
    title: "Enregistrement",
    description: "Enregistrement studio haute qualité avec équipement professionnel et ingénieur du son expérimenté.",
    icon: "Mic2",
    features: [
      "Cabines insonorisées",
      "Microphones premium",
      "Enregistrement multipiste",
      "Direction artistique"
    ]
  },
  {
    id: 2,
    title: "Mixage",
    description: "Mixage professionnel pour équilibrer et sublimer tous les éléments de votre production.",
    icon: "Sliders",
    features: [
      "Console analogique et numérique",
      "Traitement audio avancé",
      "Révisions incluses",
      "Export multi-format"
    ]
  },
  {
    id: 3,
    title: "Mastering",
    description: "Finalisation et optimisation de vos morceaux pour tous les supports de diffusion.",
    icon: "Disc3",
    features: [
      "Mastering stéréo",
      "Optimisation streaming",
      "Références professionnelles",
      "DDP pour pressage"
    ]
  },
  {
    id: 4,
    title: "Production",
    description: "Accompagnement complet dans la création et production de vos projets musicaux.",
    icon: "Music2",
    features: [
      "Arrangements musicaux",
      "Composition originale",
      "Programmation MIDI",
      "Sound design"
    ]
  }
];

export const pricingPackages = [
  {
    id: 1,
    name: "Découverte",
    price: "350",
    duration: "4h",
    description: "Idéal pour tester le studio",
    features: [
      "4 heures d'enregistrement",
      "Ingénieur du son inclus",
      "Mixage de base",
      "1 révision",
      "Export MP3 & WAV"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Standard",
    price: "800",
    duration: "journée",
    description: "Le choix le plus populaire",
    features: [
      "10 heures d'enregistrement",
      "Ingénieur du son professionnel",
      "Mixage avancé",
      "3 révisions",
      "Export multi-formats",
      "Mastering inclus"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Premium",
    price: "2500",
    duration: "semaine",
    description: "Pour projets ambitieux",
    features: [
      "40 heures d'enregistrement",
      "Producteur + ingénieur",
      "Mixage & mastering pro",
      "Révisions illimitées",
      "Tous formats d'export",
      "Archivage cloud 1 an",
      "Session visio disponible"
    ],
    popular: false
  }
];

export const portfolioItems = [
  {
    id: 1,
    artist: "Les Échos Urbains",
    project: "Album 'Résonance'",
    genre: "Hip-Hop/Rap",
    year: "2024",
    image: "https://images.unsplash.com/photo-1762917903361-99e0164dbcc5",
    description: "Enregistrement, mixage et mastering complet"
  },
  {
    id: 2,
    artist: "Marie Dulac",
    project: "EP 'Lumières'",
    genre: "Pop/Électro",
    year: "2024",
    image: "https://images.pexels.com/photos/7086732/pexels-photo-7086732.jpeg",
    description: "Production et arrangement musical"
  },
  {
    id: 3,
    artist: "The Midnight Collective",
    project: "Single 'Horizon'",
    genre: "Rock Alternatif",
    year: "2024",
    image: "https://images.unsplash.com/photo-1761959152201-4e76f3e972c1",
    description: "Enregistrement live et mixage"
  },
  {
    id: 4,
    artist: "DJ Nexus",
    project: "Track 'Pulse'",
    genre: "Électronique",
    year: "2023",
    image: "https://images.pexels.com/photos/7086737/pexels-photo-7086737.jpeg",
    description: "Production et mastering"
  }
];

export const equipment = [
  {
    category: "Microphones",
    items: ["Neumann U87", "AKG C414", "Shure SM7B", "Royer R-121"]
  },
  {
    category: "Préamplis",
    items: ["Neve 1073", "Universal Audio 610", "API 512c"]
  },
  {
    category: "Console",
    items: ["SSL AWS 948", "Pro Tools HDX", "Avid S6"]
  },
  {
    category: "Monitoring",
    items: ["Genelec 8351B", "Yamaha NS-10", "Auratone 5C"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Thomas Martin",
    role: "Artiste Indépendant",
    content: "Une expérience exceptionnelle ! L'équipe est professionnelle et à l'écoute. Le son obtenu dépasse mes attentes.",
    rating: 5
  },
  {
    id: 2,
    name: "Sophie Leroux",
    role: "Productrice",
    content: "Studio au top avec du matériel de qualité. L'ingénieur du son est d'un grand talent. Je recommande vivement !",
    rating: 5
  },
  {
    id: 3,
    name: "Alex Dubois",
    role: "Musicien",
    content: "Ambiance créative et résultats professionnels. C'est devenu mon studio de référence pour tous mes projets.",
    rating: 5
  }
];
